export default {
  OTHER_CATEGORY_ID: 91,
  PERMITTED_COUNTRIES_CODE: ['CH', 'DE', 'FR'],
  AUDIENCE_AGE: [18, 85],
};
